import React, { useEffect } from "react";
import GuideSection from "../components/guide/GuideSection";
import { oapiGuide } from "../components/guide/guideContent";
import { formatPrice } from "../utils/formatPrice";
import { useNavigate } from "react-router-dom";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { useDispatch } from "react-redux";
import { addToCart } from "../redux/actions/CartActions";
import pricing from "../assets/data/pricing.json";
import serviceCode from "../assets/data/serviceCode.json";
import { addToServiceList } from "../redux/actions/ServiceListActions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaCheck, FaTimes } from "react-icons/fa";

const protectionOptions = [
  {
    label: "Oui",
    value: true,
    description:
      "Nous procéderons à la protection de votre nom d'entreprise via l'Organisation Africaine de la Propriété Intellectuelle (OAPI), afin d'éviter que d'autres entités l'utilisent.",
    icon: <FaCheck size={35} color="green" />,
  },
  {
    label: "Non",
    value: false,
    description:
      "Vous ne ferez pas appel à l'OAPI pour protéger votre nom d'entreprise, et vous serez responsable de toute utilisation de ce nom par d'autres entités.",
    icon: <FaTimes size={35} color="red" />,
  },
];

function Oapi() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentStep = "Services";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Handle option selection
  const handleOptionSelect = async (option) => {
    if (option) {
      await dispatch(
        addToCart({
          oapi: {
            amount: pricing.oapi,
          },
        }),
      );
      await dispatch(
        addToServiceList({
          code: serviceCode.oapi,
          billing: "lifetime",
        }),
      );
    }

    // navigate("/bank");
    navigate("/domiciliation");
  };

  const handleSkipClick = () => {
    // navigate("/bank");
    navigate("/domiciliation");
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingBottom: "40px" }}>
      <Header />
      <ProgressBar steps={steps} currentStep={currentStep} />

      {/* Title Section */}
      <>
        <div
          className="container mt-4 text-center"
          style={{ maxWidth: "800px" }}
        >
          <h4 className="text-2xl font-semibold">
            Voulez-vous <span style={{ color: "#FF5500" }}>sécuriser</span> le
            nom de votre entreprise en l'enregistrant auprès de l'
            <span style={{ color: "#FF5500" }}>OAPI</span> ?
          </h4>
        </div>

        {/* Option Selection Boxes */}
        <div className="container mt-4 d-flex justify-content-center">
          <div className="row w-100" style={{ maxWidth: "600px" }}>
            {protectionOptions.map((option, index) => (
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${index}`}>
                    {option.description}
                  </Tooltip>
                }
              >
                <div className="col-lg-6 mb-4" key={index}>
                  <div
                    className="option-box d-flex align-items-center justify-content-center flex-column"
                    onClick={() => handleOptionSelect(option.value)}
                    style={{
                      height: "200px",
                      border: "2px solid #ddd",
                      borderRadius: "8px",
                      padding: "20px",
                      cursor: "pointer",
                      transition: "border-color 0.3s",
                      textAlign: "center",
                      color: "#000",
                      position: "relative",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.borderColor = "#FF5500")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.borderColor = "#ddd")
                    }
                  >
                    {option.icon}

                    <span style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
                      {option.label}

                      {option.label === "Oui" && (
                        <div
                          style={{
                            fontSize: "0.9rem",
                            textAlign: "center",
                          }}
                        >
                          <span style={{ color: "#FF5500", fontWeight: "400" }}>
                            {formatPrice(pricing.oapi)}
                          </span>
                        </div>
                      )}
                    </span>
                  </div>
                </div>
              </OverlayTrigger>
            ))}
          </div>
        </div>

        <div className="container text-center mt-3">
          <span
            onClick={handleSkipClick}
            style={{ color: "#3392FF", cursor: "pointer" }}
          >
            Décider plus tard
          </span>
        </div>

        <GuideSection {...oapiGuide} />
      </>
    </div>
  );
}

export default Oapi;
